export default __webpack_public_path__ + "static/media/arras13.5c6f0010.jpg";